var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/images.ts
import { onlyClient } from "@adornis/base/decorators/onlyClient.js";
import { onlyServer } from "@adornis/base/decorators/onlyServer.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { pipeline } from "stream";
import { AdornisFile, AdornisFileMeta } from "./files.js";
var ImageFileMeta = class extends AdornisFileMeta {
  constructor(doc) {
    super(doc);
  }
};
ImageFileMeta._class = "ImageFileMeta";
__decorateClass([
  Field((type) => String)
], ImageFileMeta.prototype, "previewBase64", 2);
ImageFileMeta = __decorateClass([
  Entity()
], ImageFileMeta);
var ImageFile = class extends AdornisFile {
  getServeLink(options) {
    return super.getServeLink(options);
  }
  getDownloadLink(options) {
    return super.getDownloadLink(options);
  }
  static getServeLink(fileID, options) {
    return super.getServeLink(fileID, options);
  }
  static getDownloadLink(fileID, options) {
    return super.getDownloadLink(fileID, options);
  }
  static canHandleFile(retrievedFile) {
    return retrievedFile.mimetype.startsWith("image") && retrievedFile.mimetype !== "image/pdf";
  }
  static async _serveFileFromPath({
    request,
    response,
    fileID,
    path,
    contentType,
    options
  }) {
    const sharp = (await import("sharp")).default;
    let transformer = sharp();
    if (request.headers.accept?.includes("image/webp")) {
      const format = "webp";
      transformer = transformer[format]();
      response.setHeader("Content-type", "image/" + format);
    }
    if (options.size) {
      const [width, height] = options.size.split("x").map((x) => +x);
      if (!isNaN(width) || !isNaN(height)) {
        transformer = transformer.resize(width || void 0, height || void 0, {
          fit: request.query.sharpfit === "contain" ? sharp.fit.contain : request.query.sharpfit === "cover" ? sharp.fit.cover : void 0,
          background: { r: 0, g: 0, b: 0, alpha: 0 }
        });
      }
    }
    pipeline(await this._readFromPath(path), transformer, response, (err) => {
      if (err)
        console.warn(`PIPELINE WITH SHARP ERROR (${path}, ${options.size}): `, err);
    });
  }
  static async _setCustomFileMeta(file, path) {
    if (!path)
      path = file.getFullPath();
    if (!file.meta)
      throw new Error("file.meta is falsy, should not happen");
    if (!file.meta.mimetype.startsWith("image"))
      throw new Error("ImageFile can only handle images, not files with mimetype " + file.meta.mimetype);
    const previewBase64 = (await (await import("sharp")).default(path).resize(10, 10).toBuffer()).toString("base64");
    file.meta = new ImageFileMeta({
      fileName: file.meta.fileName,
      size: file.meta.size,
      mimetype: file.meta.mimetype,
      md5: file.meta.md5,
      extension: file.meta.extension,
      previewBase64
    });
  }
  static async upload(file, { acceptFileTypes, maxImageSize, additionalInfo = {} } = {}) {
    let formattedFile = file;
    if (maxImageSize) {
      const reduce = (await import("image-blob-reduce")).default();
      const blob = await reduce.toBlob(file, { max: maxImageSize });
      if (blob.size < file.size)
        formattedFile = new File([blob], file.name, {
          lastModified: file.lastModified,
          type: file.type
        });
    }
    return super.upload(formattedFile, { acceptFileTypes, additionalInfo });
  }
};
ImageFile._class = "ImageFile";
__decorateClass([
  onlyServer
], ImageFile, "canHandleFile", 1);
__decorateClass([
  onlyServer
], ImageFile, "_serveFileFromPath", 1);
__decorateClass([
  onlyServer
], ImageFile, "_setCustomFileMeta", 1);
__decorateClass([
  onlyClient
], ImageFile, "upload", 1);
ImageFile = __decorateClass([
  Entity()
], ImageFile);
export {
  ImageFile,
  ImageFileMeta
};
